<template>
    <div v-if="visible" class="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
      <div class="bg-white p-6 rounded-md w-1/4">
        <h3 class="text-lg font-semibold mb-4">Enter Filename</h3>
        <input
          v-model="filename"
          class="w-full p-2 border border-gray-300 rounded mb-4"
          placeholder="Filename (without extension)"
        />
        <div class="flex justify-end space-x-2">
          <form-button class="w-20" color="gray" @click="cancel">Cancel</form-button>
          <form-button class="w-20" color="success" @click="save">Save</form-button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, watch } from 'vue';
  
  const props = defineProps({
    visible: Boolean,
    filenamePreset: String, // v-model:filenamePreset="userFilename"
  });
  
  const emit = defineEmits(['update:visible', 'update:filenamePreset', 'save']);
  
  const filename = ref(props.filenamePreset || '');
  
  // Ensure filename updates when filenamePreset changes from parent
  watch(() => props.filenamePreset, (newVal) => {
    filename.value = newVal;
  });
  
  // Sync filename back to parent when edited
  watch(filename, (newVal) => {
    emit('update:filenamePreset', newVal);
  });
  
  const cancel = () => {
    emit('update:visible', false); // Close modal
  };
  
  const save = () => {
    emit('save', filename.value); // Emit save event with filename
    emit('update:visible', false); // Close modal after saving
  };
  </script>
  